import Vue from 'vue'
import Router from 'vue-router'
const Index=()=>import('@/vuepage/index/Index')
const HousesList=()=>import('@/vuepage/location/HousesList')
const Location=()=>import('@/vuepage/location/Location')
const HouseTypeOption=()=>import('@/vuepage/location/HouseTypeOption')
const HouseTypeList=()=>import('@/vuepage/location/HouseTypeList')
const HouseCaseList=()=>import('@/vuepage/location/HouseCaseList')
const HouseCaseDetail=()=>import('@/vuepage/house_case_detail/HouseCaseDetail')
const HouseGoodsDetail=()=>import('@/vuepage/house_goods_detail/HouseGoodsDetail')
const HouseShoppingCart=()=>import('@/vuepage/shopping_cart/HouseShoppingCart')
const Survey=()=>import('@/vuepage/survey/survey')
const SurveyQuestion=()=>import('@/vuepage/survey/surveyQuestion')
const ChestDetail=()=>import('@/vuepage/chest_detail/ChestDetail')
const Gift=()=>import('@/vuepage/gift/gift')
const Info=()=>import('@/vuepage/info/Info')
const MyTags=()=>import('@/vuepage/my_tags/MyTags')
const MyHomeInit=()=>import('@/vuepage/my_home_init/MyHomeInit')
const Contact=()=>import('@/vuepage/contact/Contact')
const Video=()=>import('@/vuepage/video/Video')
const SignUp=()=>import('@/vuepage/signup/SignUp')
const GroupCoupon=()=>import('@/vuepage/group_coupon/GroupCoupon')
const GroupCouponDetail=()=>import('@/vuepage/group_coupon_detail/GroupCouponDetail')
const OrderFilling=()=>import('@/vuepage/order_filling/OrderFilling')
const MyAddr=()=>import('@/vuepage/my_addr/MyAddr')
const AddMyAddr=()=>import('@/vuepage/add_my_addr/AddMyAddr')
const PayResult=()=>import('@/vuepage/pay_result/PayResult')
const selfServiceRoom_Login=()=>import('@/vuepage/self_service_room/login/Login')
const selfServiceRoom_SelectBuildings=()=>import('@/vuepage/self_service_room/select_buildings/SelectBuildings')
const selfServiceRoom_SelectRoom=()=>import('@/vuepage/self_service_room/select_room/SelectRoom')
const selfServiceRoom_Booked=()=>import('@/vuepage/self_service_room/booked/Booked')
const selfServiceRoom_Policy=()=>import('@/vuepage/self_service_room/policy/Policy')
const selfServiceRoom_Registration=()=>import('@/vuepage/self_service_room/registration/Registration')
const plainText=()=>import('@/vuepage/plainText/PlainText')

const TestPage=()=>import('@/vuepage/test_page/TestPage')
Vue.use(Router)

//noinspection JSAnnotator
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/housesList',
      name: 'HousesList',
      component: HousesList
    },
    {
      path: '/location',
      name: 'Location',
      component: Location
    },
    {
      path: '/houseTypeOption',
      name: 'HouseTypeOption',
      meta: {title: '选择您家，免费获取方案'},
      component: HouseTypeOption
    },
    {
      path: '/houseTypeList',
      name: 'HouseTypeList',
      component: HouseTypeList
    },
    {
      path: '/houseCaseList',
      name: 'HouseCaseList',
      component: HouseCaseList
    },
    {
      path: '/houseCaseDetail',
      name: 'HouseCaseDetail',
      component: HouseCaseDetail
    },
    {
      path: '/houseGoodsDetail',
      name: 'HouseGoodsDetail',
      component: HouseGoodsDetail
    },
    {
      path: '/houseShoppingCart',
      name: 'HouseShoppingCart',
      component: HouseShoppingCart
    },
    {
      path: '/survey',
      name:'Survey',
      component: Survey
    },
    {
      path: '/surveyQuestion',
      name:'SurveyQuestion',
      component: SurveyQuestion
    },
    {
      path: '/chestDetail',
      name: 'ChestDetail',
      component: ChestDetail
    },
    {
      path: '/gift',
      name:'Gift',
      component: Gift
    },
    {
      path: '/myTags',
      name: 'MyTags',
      component: MyTags
    },
    {
      path: '/myHomeInit',
      name: 'MyHomeInt',
      component: MyHomeInit
    },
    {
      path: '/info',
      name: 'Info',
      component: Info
    },
    {
      path: '/contact',
      name: 'Contact',
      meta: { title: '联系我们' },
      component: Contact
    },
    {
      path: '/video',
      name: 'Video',
      component: Video
    },
    {
      path: '/signup',
      name: 'SignUp',
      meta: { title: '用户注册' },
      component: SignUp
    },
    {
      path: '/groupCoupon',
      name: 'GroupCoupon',
      component: GroupCoupon
    },
    {
      path: '/groupCouponDetail',
      name: 'GroupCouponDetail',
      meta: { title: '礼券活动' },
      component: GroupCouponDetail
    },
    {
      path: '/orderFilling',
      name: 'OrderFilling',
      meta: { title: '填写订单' },
      component: OrderFilling
    },
    {
      path: '/myAddr',
      name: 'MyAddr',
      meta: { title: '我的地址' },
      component: MyAddr
    },
    {
      path: '/addMyAddr',
      name: 'AddMyAddr',
      meta: { title: '填写地址' },
      component: AddMyAddr
    },
    {
      path: '/payResult',
      name: 'PayResult',
      meta: { title: '支付结果' },
      component: PayResult
    },
    {
      path: '/selfServiceRoom_login',
      name: 'SelfServiceRoom_Login',
      meta: { title: '魔方屋登录注册' },
      component: selfServiceRoom_Login
    },
    {
      path: '/selfServiceRoom_selectBuildings',
      name: 'SelfServiceRoom_SelectBuildings',
      meta: { title: '魔方屋未来样板间预约' },
      component: selfServiceRoom_SelectBuildings
    },
    {
      path: '/selfServiceRoom_SelectRoom',
      name: 'SelfServiceRoom_SelectRoom',
      meta: { title: '魔方屋未来样板间预约' },
      component: selfServiceRoom_SelectRoom
    },
    {
      path: '/selfServiceRoom_Booked',
      name: 'SelfServiceRoom_Booked',
      meta: { title: '魔方屋未来样板间预约' },
      component: selfServiceRoom_Booked
    },
    {
      path: '/selfServiceRoom_Policy',
      name: 'SelfServiceRoom_Policy',
      meta: { title: '魔方屋未来样板间预约' },
      component: selfServiceRoom_Policy
    },
    {
      path: '/selfServiceRoom_Registration',
      name: 'SelfServiceRoom_Registration',
      meta: { title: '魔方屋未来样板间预约' },
      component: selfServiceRoom_Registration
    },
    {
      path: '/productDetail',
      name: 'ProductDetail',
      meta: {title: '定制柜'},
      component: () => import('@/vuepage/product_detail/ProductDetail')
    },
    {
      path: '/productComponentList',
      name: 'ProductComponentList',
      meta: {title: '组件列表'},
      component: () => import('@/vuepage/product_component_list/ProductComponentList')
    },
    {
      path: '/plainText',
      name: 'PlainText',
      component: () => import('@/vuepage/plainText/PlainText')
    },
    {
      path: '/userMessage',
      name: 'UserMessage',
      meta: { title: '消息详情' },
      component: () => import('@/vuepage/user_message/UserMessage')
    },
    {
      path: '/viewShapeSpark',
      name: 'ViewShapeSpark',
      meta: { title: '案列展示' },
      component: () => import('@/vuepage/view_shape_spark/ViewShapeSpark')
    },


    {
      path: '/testpage',
      name: 'TestPage',
      meta: { title: '测试页面' },
      component: TestPage
    },
  ]
})
